<template>
<div>

</form>
    <section>
        
        <div class="left">
        
                <label>
                    First Name
                </label><small ref="firstNameError" class="invalid-feedback"></small>
                <input @blur="checkFirstName" v-model="message.first_name" ref="first_name">
           
        </div>
        <div class="right">
            <label>
                Last Name
            </label><small ref="lastNameError" class="invalid-feedback"></small>
            <input @blur="checkLastName" v-model="message.last_name" ref="last_name">
            
        </div>
    </section>
    <section>
        <label>
            Email
        </label><small ref="emailError" class="invalid-feedback"></small>
        <input @blur="checkEmail" v-model="message.email" ref="email">
        
    </section>
	<section>
        <label>
            Mobile Number
        </label><small ref="phoneError" class="invalid-feedback"></small>
        <input @blur="checkPhone" v-model="message.phone" ref="phone">
        
    </section>
    <section>

        <label>
            Subject
        </label><small ref="subjectError" class="invalid-feedback"></small>
        <input @input="checkSubject" v-model="message.subject" ref="subject">
        

    </section>
    <section>
        <label>
            Message
        </label><small ref="messageError" class="invalid-feedback"></small>
        <TextareaAutosize v-model="message.message" :min-height="150" :max-height="150" ref="message">
        </TextareaAutosize>
        
    </section>

    <button @click="sendMessage" class="btn btn-primary">Submit</button>
    </form>
</div>
</template>

<script>
import axios from "axios";
import Validation from "@/mixins/Validation";

export default {

    name: "ContactForm",

    mixins: [
        Validation
    ],

    data() {
        return {
            message: {
                first_name: "",
                last_name: "",
                email: "",
				phone: "",
                subject: "",
                message: ""
            }
        }
    },

    methods: {
        checkFirstName() {
            if (!(this.validName(this.message.first_name))) {
                this.$refs.first_name.classList.add("is-invalid");
				this.$refs.firstNameError.innerHTML = "Required";
                return false;
            }
            this.$refs.first_name.classList.remove("is-invalid");
            return true;
        },
        checkLastName() {
            if (!(this.validName(this.message.last_name))) {
                this.$refs.last_name.classList.add("is-invalid");
				this.$refs.lastNameError.innerHTML = "Required";
                return false;
            }
            this.$refs.last_name.classList.remove("is-invalid");
            return true;
        },
        checkEmail() {
			if (!(this.notEmpty(this.message.email))) {
                this.$refs.email.classList.add("is-invalid");
				this.$refs.emailError.innerHTML = "Required";
                return false;
            }
            if (!(this.validEmail(this.message.email))) {
                this.$refs.email.classList.add("is-invalid");
				this.$refs.emailError.innerHTML = "Invalid Email";
                return false;
            }
            this.$refs.email.classList.remove("is-invalid");
            return true;
        },
		checkPhone() {
			if (!(this.notEmpty(this.message.phone))) {
                this.$refs.phone.classList.add("is-invalid");
				this.$refs.phoneError.innerHTML = "Required";
                return false;
            }

            this.$refs.phone.classList.remove("is-invalid");
            return true;
        },
        checkSubject() {
            if (!(this.notEmpty(this.message.subject))) {
                this.$refs.subject.classList.add("is-invalid");
                this.$refs.subjectError.innerHTML = "Required";
                return false;
            }
            this.$refs.subject.classList.remove("is-invalid");
            return true;
        },
        checkMessage() {
            if (!(this.notEmpty(this.message.message))) {
                this.$refs.message.$el.classList.add("is-invalid");
                this.$refs.messageError.innerHTML = "Required";
                return false;
            }
            this.$refs.message.$el.classList.remove("is-invalid");
            return true;
        },

        sendMessage() {
            if (!(this.checkFirstName() &
                    this.checkLastName() &
                    this.checkEmail() &
					this.checkPhone() &
                    this.checkSubject() &
                    this.checkMessage())) {
                return;
            }

            var temp = this;
            axios.post("/api/contactus", this.message).then(function (response) {
                temp.message = {
                    first_name: "",
                    last_name: "",
                    email: "",
                    subject: "",
                    message: ""
                };
                var toastInstance = temp.$toasted.show("Your message has been sent successfully.", {
                    duration: "3000",
                    className: "toast-success",
                    position: "top-center"
                });
            }).catch(function () {
                var toastInstance = temp.$toasted.show("An error has occured, please try again.", {
                    duration: "3000",
                    className: "toast-warning",
                    position: "top-center"
                });
            });
        }
    }

}
</script>
